export default [
  {
    name: 'Дом для постоянного проживания',
    key: false,
  },
  {
    name: 'Дача',
    key: true,
  },
];
